import { render, staticRenderFns } from "./data-processing-card.vue?vue&type=template&id=ccc487d4&scoped=true"
import script from "./data-processing-card.vue?vue&type=script&lang=js"
export * from "./data-processing-card.vue?vue&type=script&lang=js"
import style0 from "./data-processing-card.vue?vue&type=style&index=0&id=ccc487d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc487d4",
  null
  
)

export default component.exports